import React from "react";
import styled from "styled-components";
import { Box, Paper, PaperProps } from "@material-ui/core";

export const GrayBoxContainer = styled(({ spacing, enableMargin, ...props }) => <Paper {...props} />)<
    PaperProps & { spacing?: number; enableMargin?: boolean }
>`
    padding: ${({ theme, spacing = 2 }) => theme.spacing(spacing)}px;
    background-color: ${({ theme }) => theme.palette.grey["100"]};
    margin-bottom: ${({ theme, enableMargin }) => `${enableMargin ? theme.spacing(2) : 0}px`};

    &:last-of-type {
        margin-bottom: 0;
    }

    & > * {
        margin-bottom: ${({ theme }) => theme.spacing(2)}px;

        &:last-of-type {
            margin-bottom: 0;
        }
    }
`;

export const ButtonContainer = styled(Box)`
    & > * {
        &:first-of-type {
            margin-left: 0;
        }

        margin-left: ${({ theme }) => `${theme.spacing(2)}px`};
    }
`;
